import { toast } from 'react-toastify';
import api from './index';
import { Cookies } from 'react-cookie';


export const createUser = async formData => {
  const cookie = new Cookies();
  return new Promise(async (resolve, reject) => {
    try {
      const res = await api.post('/auth/sign-up', formData);
      localStorage.setItem('data', JSON.stringify(res.data.data));
      cookie.set('email', res.data.data.email);
      resolve(res);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const { status, data } = error.response;

        if (status === 400) {
          // Bad Request: likely due to validation errors
          toast.error(`Bad Request: ${data.message || 'Please check the form data.'}`);
        } else if (status === 409) {
          // Conflict: likely due to duplicate email or username
          toast.error(`Conflict: ${data.message || 'Email or username already exists.'}`);
        } else {
          toast.error(`Error: ${data.message || 'Something went wrong please refresh the page.'}`);
        }
      } else if (error.request) {
        // The request was made but no response was received
        toast.error('No response from server. Please try again later.');
      } else {
        // Something happened in setting up the request that triggered an Error
        toast.error(`Error: ${error.message}`);
      }
      reject(error);
    }
  });
};
